/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

$('.forMobile').parent().parent().parent().parent().hide();
$('.forDesktop').parent().parent().parent().parent().show();

if ($(window).width() < 768){
  $('.forMobile').parent().parent().parent().parent().show();
  $('.forDesktop').parent().parent().parent().parent().hide();
}

/* Over 18 Code Start */

function noClick() {
  return $("#check18cnt").html('<h1>Sorry, this site is only available to persons aged 18 years or older</h1><p><a href="" class="negativeBtn">Back</a></p>'), !1;
}

var Cookie = {};
Cookie.set = function (n, t, i, r, u, f) {
  document.cookie = n + "=" + escape(t) + (i ? "; expires=" + i : "") + (r ? "; path=" + r : "") + (u ? "; domain=" + u : "") + (f ? "; secure" : "");
};
Cookie.get = function (n) {
  var i = n + "=",
      r = document.cookie.indexOf(i),
      t;
  return r == -1 ? null : ((t = document.cookie.indexOf(";", r + i.length)), t == -1 && (t = document.cookie.length), unescape(document.cookie.substring(r + i.length, t)));
};
Cookie.del = function (n, t, i) {
  getCookie(n) && (document.cookie = n + "=" + (t ? "; path=" + t : "") + (i ? "; domain=" + i : "") + "; expires=Thu, 01-Jan-70 00:00:01 GMT");
};

$(function () {
  var t = null;
  t = Cookie.get("buzzstop");
  t != "1" && ($("#check18").show());
  $("#check18 .positiveBtn").click(function () {
    return Cookie.set("buzzstop", "1"), $("#check18").hide(), n.appendTo(document.body).remove(), !1;
  });
});

/* Over 18 Code End */